import React from "react";
import { Navigate, useLocation, useParams, useSearchParams } from "react-router-dom";
import { legacyIndividualRedirectTarget } from "utils/accountRoutes";

type LegacyIndividualAccountRedirectProps = {
  children: React.ReactNode;
};

export const LegacyIndividualAccountRedirect: React.FC<
  LegacyIndividualAccountRedirectProps
> = ({ children }) => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const redirectTo = legacyIndividualRedirectTarget(
    location.pathname,
    id,
    searchParams.get("accountType")
  );

  if (redirectTo) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};
